import { render, staticRenderFns } from "./ListaEnCurso.vue?vue&type=template&id=32167c33&"
import script from "./ListaEnCurso.vue?vue&type=script&lang=js&"
export * from "./ListaEnCurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports